import React, { Component } from 'react';
import PropTypes from 'prop-types';


class ExternalRedirect extends Component {

  static propTypes = {
    link: PropTypes.string
  };

  componentDidMount () {
    window.location.replace(this.props.link);
  }

  render () {
    return (
      <div className='text-center'>
        <p>
          Yönlendiriliyorsunuz...
        </p>
      </div>
    );
  }
}

export default ExternalRedirect;
